import { render, staticRenderFns } from "./WishlistIcon.vue?vue&type=template&id=4e0cf77e&scoped=true&"
import script from "./WishlistIcon.vue?vue&type=script&lang=js&"
export * from "./WishlistIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0cf77e",
  null
  
)

export default component.exports